
export const ADMIN_ROLE = 'Admin';
export const VIEWER_ROLE = 'Viewer';
